if (typeof Object.assign !== 'function') {
	Object.assign = function (target, varArgs) { // .length of function is 2
		'use strict';
		if (target == null) { // TypeError if undefined or null
			throw new TypeError('Cannot convert undefined or null to object');
		}
		let to = Object(target);
		for (let index = 1; index < arguments.length; index++) {
			let nextSource = arguments[index];
			if (nextSource != null) { // Skip over if undefined or null
				for (let nextKey in nextSource) {
					// Avoid bugs when hasOwnProperty is shadowed
					if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
						to[nextKey] = nextSource[nextKey];
					}
				}
			}
		}
		return to;
	};
}
VLW.Site = class {
	constructor() {
		this._scrollCache = {};
		this.controllersByUrl     = {};
		this.controllersById      = {};
		this.loadingUrl           = null;
		this.rendered             = 0;
		this.currentPageBodyClass = "";
		this.events={onLoadStart: new signals.Signal(),onLoadComplete: new signals.Signal(),};
		window.site = this;
		this.initBind(this);
		this.init();
	}

	initBind(currCls) {
		if (currCls == null || typeof currCls === "undefined" || currCls.__proto__ == null || typeof currCls.__proto__ === "undefined") return;
		let names = Object.getOwnPropertyNames(currCls.__proto__);
		for (let memberName of names) {
			// skip getters/setters
			let descriptor = Object.getOwnPropertyDescriptor(currCls.__proto__, memberName);
			if (descriptor && (descriptor.get || descriptor.set)) {
				continue;
			}
			if (typeof(this[memberName]) === "function" && memberName !== "constructor") {
				this[memberName] = this[memberName].bind(this);
			}
		}
		this.initBind(currCls.__proto__);
	}

	init() {
		this.initScroll();
		this.initResize();
		this.initAddressManager();
		this.initControllers();
		this.launch();
		let	orientation_ga = (window.innerWidth > window.innerHeight) ? "paysage" : "portrait";
			this.trackEvent("Orientation", "Initial", orientation_ga);
			window.addEventListener('orientationchange',  () =>{
				this.trackEvent("Orientation", "Change", ((window.innerWidth > window.innerHeight) ? "paysage" : "portrait"));
			});

	}

	 trackEvent(category, action, label) {
		(typeof window.ga !== "undefined" && window.ga('send', 'event', category, action, label))
	}

	 trackPage(title, location) {
		(typeof window.ga !== "undefined" && window.ga('send', 'pageview', {"title": title, "location": location}));
		(typeof window.fbq !== "undefined" && fbq('track', 'PageView'));
		
		
	}

	trackVar(dimension, dimensionValue) {
		(typeof window.ga !== "undefined" && window.ga('set', dimension, dimensionValue));
	}

	initScroll(){
		if ('scrollRestoration' in history) {
		  // Back off, browser, I got this...
		  history.scrollRestoration = 'manual';
		}
		document.defaultView.addEventListener("scroll", this.onScroll, {
			capture: true
		}, true);
	}

	initResize() {
		this.onResize();
		window.addEventListener("resize", this.onResize);
	}

	initAddressManager() {
		window.addEventListener('popstate', () => {
			return this.loadUrl(window.location.pathname)
		});
		this.currentPathname = this.currentContentPathname = window.location.pathname + window.location.search; // Nécessaire pour les paramètres en get (qrcodes et analytics)
		this.bindAjaxLinks();
	}

	initControllers() {
		[...document.querySelectorAll("[data-cfg]")].sort((a) => JSON.parse(a.getAttribute("data-cfg")).hasOwnProperty("parent_id")).forEach((e) => {
			this.initController(e, true, null, true)
		});
		VLW.initMutation(document.body);
	}

	initController(el, rendered, data, first, controllersUrls) {
		let controllerClass;
		let cfg           = JSON.parse(el.getAttribute("data-cfg"));
		let cid           = cfg.id;
		let controllerUrl = false;
		if (this.controllersById[cid] && this.controllersById[cid] !== 1 && this.controllersById[cid].activated) {
			this.controllersById[cid].reload(el);
			return;
		}
		controllerUrl     = (controllersUrls && controllersUrls[cid]) ? controllersUrls[cid] : controllerUrl;
		controllerClass   = (typeof VLW.controllers[cfg.ctrl] === "undefined") ? VLW.controllers["defaut"] : VLW.controllers[cfg.ctrl];
		cfg.rendered      = rendered;
		cfg.controllerUrl = controllerUrl;
		cfg.jsonData      = data;
		cfg.site = this;
		this.registerController(new controllerClass(el, cfg), first);
		/*
		try{
			this.registerController(new controllerClass(el, cfg), first);
		} catch(e) {
			console.error(new Error(`Erreur à la construction de VLW.controllers.${cfg.ctrl}`));
			console.log("%c	"+e,"background-color:#B36D35");

			throw e;
		}*/
	}
	registerController(controller, first) {
		let {grp: groupId, id: contentId, parent_id: parentId} = controller;
		let byUrl                                              = this.controllersByUrl[this.currentContentPathname] = this.controllersByUrl[this.currentContentPathname] || {};
		if (!first) byUrl[controller.id] = controller;
		this.controllersById[contentId] = controller;
		controller.contentPathname = this.currentContentPathname;
		controller.events.ondeactivate.add(this.onControllerDeactivate);
		if (!parentId) {
			VLW.groupControllers[groupId] = VLW.groupControllers[groupId] || new  VLW.ContentGroup(true);
			VLW.groupControllers[groupId].registerController(controller);
		} else {
			(this.controllersById[parentId])?this.controllersById[parentId].registerController(controller):"";
		}
	}
	unregisterController(controller) {
		for (let url in this.controllersByUrl) {
			let obj = this.controllersByUrl[url];
			if (obj[controller.id] === controller) {
				obj[controller.id] = null;
			}
		}
		let cid = controller.id;
		if (this.controllersById[cid] === controller) this.controllersById[cid] = null;
	}

	launch() {
		(typeof this.intro === "function" && this.intro());
	}

	launchControllers(first) {
		let byUrl = first ? this.controllersById : this.controllersByUrl[this.currentContentPathname];
		if (!byUrl) return false;
		let launched = {};
		for (let id in byUrl) {
			if (byUrl[id] && !launched[id]) {
				let parent = byUrl[id].parentGroup ? byUrl[id].parentGroup.parentController : false;
				if (parent && !parent.activated) {
					parent.launch();
					launched[parent.id] = true;
				}
				if (byUrl[id].launch) {
					byUrl[id].launch();
					launched[id] = true;
				}
			}
		}
		launched = null;
	}

	onIntroComplete() {
		this.launchControllers(true);
	}

	onControllerDeactivate(controller) {
		this.unregisterController(controller);
		controller.events.ondeactivate.remove(this.onControllerDeactivate);
	}

	onResize() {
		let className = (window.innerWidth > window.innerHeight) ? "landscape" : "portrait";
		document.querySelector("html").classList.remove("landscape");
		document.querySelector("html").classList.remove("portrait");
		document.querySelector("html").classList.add(className);
		CONFIG.ORIENTATION = className;

	}
	get documentScrollElement() {
		return document.scrollingElement || document.documentElement;
	}
	onScroll(event){
		this.scrollTimeout && clearTimeout(this.scrollTimeout);
		this.scrollTimeout = setTimeout(() => {
			var scrollId, target;
			if(event.target == document){
				scrollId = "document";
				target = this.documentScrollElement;
			} else if(typeof event.target.getAttribute === "function"){
				scrollId = event.target.getAttribute("scrollid");
				target = event.target;
			}
			if(!scrollId){
				return;
			}
			var scrollState = {
				scrollTop: target.scrollTop,
				scrollLeft: target.scrollLeft
			};
			var state = this.scrollState || {};
			state[scrollId] = scrollState;
            this.scrollState = state;

		}, 100);
	}
	restoreElementScroll(domElement){
		if(!(
			history
			&& history.state
			&& history.state.scrollState
			)
		){
			return;
		}
		Object.keys(history.state.scrollState).forEach((scrollId) => {
			var state = history.state.scrollState[scrollId];
			var target;
			if(scrollId == "document"){
				return;
			} else {
				target = domElement.querySelector(`[scrollid=${scrollId}]`);
				target.setAttribute("historyScrollTop", state.scrollTop);
				target.setAttribute("historyScrollLeft", state.scrollLeft);
			}
			target.scrollTop = state.scrollTop;
			target.scrollLeft = state.scrollLeft;
		});
	}
	restoreDocumentScroll(tweenOptions = false){
		var state;
		if(!(
			history
			&& history.state
			&& history.state.scrollState
			&& history.state.scrollState['document']
			)
		){
			state = {
				scrollTop: 0,
				scrollLeft: 0
			}
		} else {
			state = history.state.scrollState['document'];
		}
		if(!tweenOptions){
            TweenLite.set(this.documentScrollElement, state);
		} else {
			let duration = 1;
			if(tweenOptions && tweenOptions.duration) {
                duration = tweenOptions.duration
            }
            let _state = {};
			Object.assign(_state, state);
			if(tweenOptions.options){
				Object.assign(_state, tweenOptions.options);
			}
            TweenLite.to(this.documentScrollElement, duration, _state);
		}
	}

	get scrollState(){
	    this._scrollState = this._scrollState || {};
		this._scrollState['document'] = {
			scrollTop: this.documentScrollElement.scrollTop,
			scrollLeft: this.documentScrollElement.scrollLeft
		};
		[...document.querySelectorAll(['scrollid'])].forEach(el => {
			var scrollId = el.getAttribute('scrollid');
			this._scrollState[scrollId] = {
				scrollTop: el.scrollTop,
				scrollLeft: el.scrollLeft
			}
		});
		return this._scrollState;
	}

	set scrollState(state){
	    this._scrollState = state;
    }

	bindAjaxLinks() {
		document.addEventListener("click", (e) => this.onClickAjax(e));
		this.updateAjaxLinks();
	}

	static isAjaxLink(el){
		return el.classList && el.classList.contains("ajax");
	}

	onClickAjax(event) {
		let el = event.target, found = false;
		while (el && found === false) {
			found = VLW.Site.isAjaxLink(el) || found;
			if (found === true) break;
			el = el.parentNode;
		}
		if (found) {
			event.preventDefault();
			event.stopPropagation();
			let skip        = el.classList.contains('skipAjax');
			let skipAddress = el.classList.contains('skipAddress');
			let url         = el.getAttribute('href');
			let backurls    = el.getAttribute('data-back-urls');
			if(backurls){
                backurls = JSON.parse(backurls);
			}
			if (skipAddress && skip) {
				return false;
			}
			if (skipAddress) {
				this.loadUrl(url, null);
				return false;
			}
			if (skip) this.skip = true;
			if(history && history.state && history.state.previousPathname && url && (history.state.previousPathname === url || (backurls && backurls.indexOf(history.state.previousPathname) !== -1)) && el.classList.contains('autoHistoryBack')){
				console.warn("Click triggers load of previousPathname. Going back in history ! To prevent this behaviour remove `autoHistoryBack` class on your link.");
				console.warn(history.state.previousPathname, url);
				history.go(-1);
				return false;
			}
			if (this.currentPathname !== url) {
				this.goTo(url);
			} else if (this.currentContentPathname !== url) {
				this.loadUrl(url, null);
			}
			return false;
		}
	}

	goBack(){
		var url;
		if(history
			&& history.state
			&& history.state.previousPathname){
			url = history.state.previousPathname;
		} else if(this.previousPathname){
			url = this.previousPathname;
		} else {
			url = "/";
		}
		this.goTo(url);
	}

	goTo(url){
		history.replaceState(this.currentHistoryState, null);
		history.pushState({
			currentPathname: url,
			previousPathname: this.currentPathname
		}, null, url);
		this.loadUrl(url, null);
	}

	get currentHistoryState(){
		var state = history.state || {};
		state.currentPathname = state.currentPathname || this.currentPathname;
		state.currentContentPathname = state.currentContentPathname || this.currentContentPathname;
		state.scrollState = this.scrollState;
		return state;
	}



	loadUrl(url, data) {
		let _data  = Object.assign({ajax: 1, activeControllersIds: this.getActiveControllersIds(), presentControllersIds: this.getPresentControllersIds()}, data);
		let ajax   = new XMLHttpRequest();
		ajax.open('POST', url, true);
		ajax.setRequestHeader('X-Requested-With'	, 'XMLHttpRequest');
		ajax.setRequestHeader("Content-type"		, "application/x-www-form-urlencoded; charset=UTF-8");
		ajax.onreadystatechange = this.ajaxResponse;
		ajax.send(Object.toQueryString(_data));
		this.loadingUrl 		= url;
		this.previousPathname 	= this.currentPathname;
		this.currentPathname 	= url;
		this.onLoadStart();
		this.events.onLoadStart.dispatch({url});
		document.body.style.cursor='wait';
		broadCaster.SITE_LOADURL.dispatch({url});
		this.isLoading = true;
	}

	ajaxResponse(e) {
		(e.currentTarget.readyState === 4 && e.currentTarget.status === 200 && this.onLoaderSuccess(JSON.parse(e.currentTarget.responseText)));
	}

	onLoaderSuccess(data) {
		//if (data && data.redirect && data.redirect !== "") {}
		this.isLoading = false;
		document.body.style.cursor='default';
		this.currentContentPathname = this.loadingUrl ? this.loadingUrl : this.currentContentPathname;
		(this.loadingUrl && this.currentPathname === this.loadingUrl && this.setPageInfo(data.json));
		this.loadingUrl = null;
		this.updateAjaxLinks();
		(data.json.parentURL && this.selectLinksFromUrl(data.json.parentURL));
		let loadedDom       = document.createElement('DIV');
		loadedDom.innerHTML = data.html;
		this.restoreElementScroll(loadedDom);
		EXTRADATA =(data && data.json && data.json.extraData)? data.json.extraData:EXTRADATA;
		[...loadedDom.querySelectorAll("[data-cfg]")].sort((a) => JSON.parse(a.getAttribute("data-cfg")).hasOwnProperty("parent_id")).forEach((e) => {
			let cfg = JSON.parse(e.getAttribute("data-cfg"));
			this.initController(e, cfg && cfg.rendered, data.json.extraData,  data.json.controllersUrls)
		});
		this.launchControllers();
		this.onLoadComplete();
        this.updateAjaxLinks();
		//this.body.removeClass('loading');
		this.events.onLoadComplete.dispatch();

	}

	parseUrlBeforeChange(url) {
		return url;
	}

	getActiveControllersIds() {
		let ids = {};
		for (let cid in this.controllersById) {
			if (this.controllersById[cid] && this.controllersById[cid].activated) ids[cid] = 1;
		}
		return ids;
	}

	getPresentControllersIds() {
		let ids = {};
		for (let cid in this.controllersById) {
			if (this.controllersById[cid]) ids[cid] = 1;
		}
		return ids;
	}

	updateAjaxLinks() {
		if (this.debug) console.log(this, arguments, 'VLW.Site updateAjaxLinks');
		let _a = document.querySelectorAll(".ajax.selected,[data-href].selected");
		let i  = 0, len = _a.length;
		for (; i < len; i++) {
			_a[i].classList.remove('selected');
		}
		_a = null;

		this.selectLinksFromUrl(this.currentPathname);
	}

	selectLinksFromUrl(url) {
		let a           = url.split('/');
		let l           = a.length;
		let matchString = a[0] + "/" + a[1];
		let _a          = [];
		for (let i = 2; i < l; i++) {
			matchString += "/" + a[i];
			_a = _a.concat(Array.prototype.slice.call(document.querySelectorAll('[href="' + matchString + '"],[data-href="' + matchString + '"]')));
		}
		let j = 0, len = _a.length;
		for (; j < len; j++) {
			_a[j].classList.add('selected');
		}
		_a = null;
	}

	replaceHtml(el, tr) {
		el.html(tr);
	}

	setPageInfo(json) {
		if (this.debug) console.log(this, arguments, 'VLW.Site setPageInfo');
		document.title = json.meta_title;
		let _alt       = document.querySelector("link[rel='alternate']");
        if (_alt && json.href_otherlang) {
        	for (let i in json.href_otherlang) {
        		let alternate = document.querySelector(`link[rel='alternate'][hreflang='${i}']`);
        		if(alternate){
					alternate.setAttribute("href",json.href_otherlang[i]);
				}
				alternate = document.querySelector(`[data-code_langue='${i}']`);
				if(alternate){
					alternate.setAttribute("href",json.href_otherlang[i]);
				}
            }
        }
		let _prev = document.querySelector("link[rel='prev']");
		let _next = document.querySelector("link[rel='next']");
		if (json.meta_prev) {
			if (!_prev) {
				let meta = document.createElement('link');
				meta.setAttribute("rel", "prev");
				meta.setAttribute("href", json.meta_prev);
				document.getElementsByTagName('head')[0].appendChild(meta);
				meta = null;
			} else {
				_prev.setAttribute('href', json.meta_prev);
			}
		}

		if (json.meta_next) {
			if (!_next) {
				let meta = document.createElement('link');
				meta.setAttribute("rel", "next");
				meta.setAttribute("href", json.meta_next);
				document.getElementsByTagName('head')[0].appendChild(meta);
				meta = null;
			} else {
				_next.setAttribute('href', json.meta_next);
			}
		}
		let toRemove = "classNull";
		if (this.currentPageBodyClass) {
			toRemove = this.currentPageBodyClass;
			//this.body.removeClass(this.currentPageBodyClass)
		}
		if (SITE_CLASS_BODY_CHANGE !== false) {
			//if (this.currentPageBodyClass && this.o__body.classList) this.o__body.classList.remove(this.currentPageBodyClass);
			this.currentPageBodyClass = json.pageBodyClass;
			if (this.o__body.classList) {
				//this.o__body.classList.add(this.currentPageBodyClass);
			}
		}
		this.currentPageBodyClass = json.pageBodyClass;
		//this.trigger('onSetPageInfo');
		site.trackPage(json.meta_title, window.location.pathname);
	}

	sanitizeUrlBeforeMatch(url) {
		return url;
	}
};
